import React from "react";
import styled from "styled-components";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import UnfoldMore from "@material-ui/icons/UnfoldMore";
import {
  Cell,
  CellProps,
} from "@sonder/ui/source/styled/fragments/Table/TableCell";

const StyledCell = styled(Cell)`
  padding-right: 0;
  > svg {
    margin-left: 0.3rem;
    width: 1.2rem;
  }
  &:hover {
    cursor: pointer;
  }
`;

// Exports
export type SortOrder = "asc" | "desc" | null;
export interface SortableCellProps extends CellProps {
  sortOrder: SortOrder;
}
export const SortableCell = ({
  children,
  sortOrder,
  ...cellProps
}: SortableCellProps) => {
  return (
    <StyledCell {...cellProps}>
      {children}
      {sortOrder === "asc" && <ExpandLess />}
      {sortOrder === "desc" && <ExpandMore />}
      {!sortOrder && <UnfoldMore />}
    </StyledCell>
  );
};
